import { OnInit, TemplateRef } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { PasswordValidation } from '../../../services/match';
import { RutValidator } from 'node_modules/ng2-rut';
import { UserService } from './../../../services/user.service';
import { MatDialog } from '@angular/material';
import { Router, ActivatedRoute } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { GLOBAL } from '../../../services/global';
var ForgotPassComponent = /** @class */ (function () {
    function ForgotPassComponent(fb, rutValidator, _userService, dialog, _router, route, spinner) {
        this.fb = fb;
        this._userService = _userService;
        this.dialog = dialog;
        this._router = _router;
        this.route = route;
        this.spinner = spinner;
        this.nombreMuni = GLOBAL.nombreMuni;
        this.hide2 = true;
        this.hide3 = true;
        this.contrasenas = this.fb.group({
            contrasena: ['', [Validators.required, Validators.minLength(6), Validators.maxLength(15)]],
            repContrasena: ['', [Validators.required, Validators.minLength(6), Validators.maxLength(15)]]
        }, {
            validator: PasswordValidation.MatchPassword
        });
    }
    ForgotPassComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.route.queryParamMap.subscribe(function (queryParams) {
            // this.userType = queryParams.get("userType");
            console.log(queryParams);
            _this.rut = queryParams.get("rut");
        });
        console.log(this.rut);
    };
    ForgotPassComponent.prototype.restablecer = function () {
        var _this = this;
        console.log(this.contrasenas);
        this.spinner.show();
        this._userService.resetPass(this.rut, this.contrasenas.value.repContrasena).subscribe(function (resp) {
            if (resp.status == 'ok') {
                _this.dialog.open(_this.passResp);
                // this._router.navigate([`/`]);
                _this.spinner.hide();
            }
            else {
                _this.dialog.open(_this.passNoResp);
                _this.spinner.hide();
            }
        });
    };
    ForgotPassComponent.prototype.redirect = function () {
        this._router.navigate(["/"]);
        this.dialog.closeAll();
    };
    return ForgotPassComponent;
}());
export { ForgotPassComponent };
